<script setup>
import { useSEO } from '../composables/seo'

const allShows = ref([])
const contestantData = ref([])

const { data } = await useFetch('/api/streaks')
// console.log('data', data.value.allShows)

allShows.value = data.value.allShows
contestantData.value = data.value.contestants

// const [
//   { data: contestantData },
//   { data: data2018 },
//   { data: data2019 },
//   { data: data2020 },
//   { data: data2021 },
//   { data: data2022 }
// ] = await Promise.all([
//   useFetch(`${useRuntimeConfig().public.hostname}/contestants.json`),
//   useFetch(`${useRuntimeConfig().public.hostname}/quiz-shows-2018.json`),
//   useFetch(`${useRuntimeConfig().public.hostname}/quiz-shows-2019.json`),
//   useFetch(`${useRuntimeConfig().public.hostname}/quiz-shows-2020.json`),
//   useFetch(`${useRuntimeConfig().public.hostname}/quiz-shows-2021.json`),
//   useFetch(`${useRuntimeConfig().public.hostname}/quiz-shows-2022.json`)
// ])
//
// console.log('cntest', data2022.value)
//
// const allShows = ref([
//   ...data2018.value,
//   ...data2019.value,
//   ...data2020.value,
//   ...data2021.value,
//   ...data2022.value
// ])

// const contestant = [...new Set(contestantData.value.map(o => o.name_id))]
const winnerList = allShows.value.map(o => o.winner_id)
// const getLongestStreak = function (winner_list) {
//   let maxCount = 0
//   let maxValues
//   winner_list.reduce(function (j, a, i, aa) {
//     if (aa[j] === a) {
//       return j
//     }
//     if (i - j === maxCount) {
//       maxValues.push(aa[j])
//     }
//     if (i - j > maxCount) {
//       maxCount = i - j
//       maxValues = [aa[j]]
//     }
//     return i
//   }, -1)
//   return { maxCount, maxValues }
// }

function compressString(str) {
  return str.reduce((acc, name) => {
    const { length: l } = acc
    if (acc[l - 1]?.name === name) {
      acc[l - 1].champCount++
      return acc
    }
    else {
      return acc.concat({
        name,
        champCount: 1,
      })
    }
  }, [])
}

// console.log(compressString(winner_list));

const orderStreaks = compressString(winnerList)

orderStreaks.sort((a, b) => {
  return a.champCount < b.champCount
})

const streaksOver3 = orderStreaks.filter(x => x.champCount > 3)

const streaksOver3List = streaksOver3.sort((a, b) => {
  return b.champCount - a.champCount
})

// const champList = [];
//
// for (let i = 0; i < 5; i++) {
//   const first = getLongestStreak(winner_list);
//   winner_list = winner_list.filter((x) => x !== first.maxValues[0]);
//   champList.push({
//     champCount: first.maxCount,
//     name: first.maxValues[0],
//     rank: 0,
//   });
// }
//
// champList.sort(function (a, b) {
//   return b.champCount - a.champCount;
// });

// const orderedUniqueScores = [
//   ...new Set(
//     champList
//       .sort((a, b) => (a.champCount > b.champCount ? -1 : 1))
//       .map((p) => p.champCount)
//   ),
// ];
//
// Object.keys(champList).forEach(function (key) {
//   let contestant = champList[key];
//   champList[key].rank = orderedUniqueScores.indexOf(contestant.champCount) + 1;
// });

function getName(nameId) {
  return contestantData.value.filter(x => x.name_id === nameId)[0].name
}

const rank1 = []
rank1.push(streaksOver3List[0])

const rank2 = []
rank2.push(streaksOver3List[1])

// const rank1 = champList
//   .filter((x) => x.rank === 1)
//   .sort((a, b) => a.name.localeCompare(b.name));
// const rank2 = champList
//   .filter((x) => x.rank === 2)
//   .sort((a, b) => a.name.localeCompare(b.name));
// const rank3 = champList
//   .filter((x) => x.rank === 3)
//   .sort((a, b) => a.name.localeCompare(b.name));
const { GenerateTags } = useSEO()
GenerateTags({ title: '⚡ Streaks', desc: 'Streaks!' })
</script>

<template>
  <div class="p-x-2 sm:p-x-10 pb-8">
    <div class="pt-4">
      <div class="sg-regular pb-6 sm:pb-10 dark:text-gray-50">
        Separating the champs from the champ-champs. Who has the longest winning
        streak > 2?
      </div>
      <div class="w-full space-y-8 sm:space-y-10 dark:text-gray-50 ">
        <div class="flex justify-center">
          <div
            class="flex pl-6 sm:pl-10 bg-gray-200/70 p-4 rounded-xl w-full md:w-4/5 lg:w-3/5 dark:bg-gray-700"
          >
            <div
              class="relative rounded-full shrink-0 sg-bold text-4xl text-white bg-[#ec1d23] h-10 w-10 flex justify-center items-center ring-4 ring-[#1E90FF] "
            >
              <div>{{ rank1?.[0].champCount }}</div>

              <div
                class="absolute inline top-9 uppercase text-sm sg-bold text-white bg-green-500 blend px-2 -skew-x-15"
              >
                <div class="skew-x-15 tracking-widest">
                  games
                </div>
              </div>
            </div>
            <div class="ml-8">
              <div
                v-for="(rank, index) in rank1"
                :key="index"
                class="sg-bold text-2xl"
              >
                {{ getName(rank.name) }}
                {{ index < rank1.length - 1 ? " & " : "" }}
              </div>
              <span
                v-for="index in rank1?.[0].champCount"
                :key="index"
                class="sg-medium uppercase tracking-tighter inline-flex"
              >champ{{ index < rank1?.[0].champCount ? "-" : "" }}</span>
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <div
            class="flex pl-6 sm:pl-10 bg-gray-200/70 p-4 rounded-xl w-full md:w-4/5 lg:w-3/5 dark:bg-gray-700"
          >
            <div
              class="relative shrink-0 rounded-full sg-bold text-4xl text-white bg-[#ec1d23] h-10 w-10 flex justify-center items-center ring-4 ring-[#1E90FF]"
            >
              <div>{{ rank2?.[0].champCount }}</div>

              <div
                class="absolute inline top-9 uppercase text-sm sg-bold text-white bg-green-500 blend px-2 -skew-x-15"
              >
                <div class="skew-x-15 tracking-widest">
                  games
                </div>
              </div>
            </div>
            <div class="ml-8">
              <div>
                <span
                  v-for="(rank, index) in rank2"
                  :key="index"
                  class="sg-bold text-2xl"
                >
                  {{ getName(rank.name) }}
                  {{ index < rank2.length - 1 ? " & " : "" }}
                </span>
              </div>
              <span
                v-for="index in rank2?.[0].champCount"
                :key="index"
                class="sg-medium uppercase tracking-tighter inline-flex"
              >champ{{ index < rank2?.[0].champCount ? "-" : "" }}</span>
            </div>
          </div>
        </div>
        <!--        <div class="flex justify-center"> -->
        <!--          <div -->
        <!--            class="flex pl-6 sm:pl-10 bg-gray-200/70 p-4 rounded-xl w-full md:w-4/5 lg:w-3/5" -->
        <!--          > -->
        <!--            <div -->
        <!--              class="relative shrink-0 rounded-full sg-bold text-4xl text-white bg-[#ec1d23] h-10 w-10 flex justify-center items-center ring-4 ring-[#1E90FF]" -->
        <!--            > -->
        <!--              <div>{{ rank3[0].champCount }}</div> -->

        <!--              <div -->
        <!--                class="absolute inline top-9 uppercase text-sm sg-bold text-white bg-green-500 blend px-2 -skew-x-15" -->
        <!--              > -->
        <!--                <div class="skew-x-15 tracking-widest">games</div> -->
        <!--              </div> -->
        <!--            </div> -->
        <!--            <div class="ml-8"> -->
        <!--              <div> -->
        <!--                <span -->
        <!--                  v-for="(rank, index) in rank3" -->
        <!--                  :key="index" -->
        <!--                  class="sg-bold text-2xl" -->
        <!--                > -->
        <!--                  {{ getName(rank.name) }} -->
        <!--                  {{ index < rank3.length - 1 ? " & " : "" }} -->
        <!--                </span> -->
        <!--              </div> -->
        <!--              <span -->
        <!--                v-for="index in rank3[0].champCount" -->
        <!--                class="sg-medium uppercase tracking-tighter" -->
        <!--                >champ{{ index < rank3[0].champCount ? "-" : "" }}</span -->
        <!--              > -->
        <!--            </div> -->
        <!--          </div> -->
        <!--        </div> -->
        <div class="">
          <!-- HTML code -->
          <!--          <div class="hoverCard"> -->
          <!--            <a href="#" class="inline-flex items-center font-bold text-gray-700 hover:text-gray-900"> -->
          <!--              <span>Contestant Name</span> -->
          <!--              <svg class="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20"> -->
          <!--                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" /> -->
          <!--                <path fill-rule="evenodd" d="M2.52 13.879a1 1 0 00.832.518l3.555.444 1.582 3.379a1 1 0 001.789 0l1.582-3.379 3.555-.444a1 1 0 00.555-1.698l-2.566-2.554.605-3.413a1 1 0 00-.894-1.178l-3.375-.253-1.497-3.237a1 1 0 00-1.789 0l-1.497 3.237-3.375.253a1 1 0 00-.894 1.178l.605 3.413-2.566 2.554a1 1 0 00-.222 1.16z" clip-rule="evenodd" /> -->
          <!--              </svg> -->
          <!--            </a> -->
          <!--            <div class="hidden absolute z-10 w-64 p-4 mt-2 text-gray-700 bg-white rounded-lg shadow-lg"> -->
          <!--              <div class="font-bold"> -->
          <!--                Last Quiz Won -->
          <!--              </div> -->
          <!--              <div class="mt-2"> -->
          <!--                Quiz Title -->
          <!--              </div> -->
          <!--              <div class="mt-2"> -->
          <!--                Score: 80% -->
          <!--              </div> -->
          <!--              <div class="mt-2 text-sm text-gray-500"> -->
          <!--                Taken on March 17, 2023 -->
          <!--              </div> -->
          <!--            </div> -->
          <!--          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* CSS code */
.hoverCard:hover .absolute {
  display: block;
}

/* Github-like styles */
.hover\:shadow-lg {
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 8px 24px rgba(149, 157, 165, 0.2);
}

.hover\:bg-white:hover {
  background-color: #f6f8fa;
}
</style>
